import { computed } from 'vue'
import { FORMATS } from '@/global/services/date'

const TAB_KEY = 'basic-info'
const HIDDEN_FORM_KEYS = ['images-deleted']

export function useBasicInfo (options) {
  const {
    trans,
    route,
    columnsContentComponent,
    unitOfMeasureItems
  } = options || {}

  const apiConfig = computed(() => ({
    get: {
      module: 'road-maintenance',
      route: `products/${route.params.id}`
    },
    post: {
      module: 'road-maintenance',
      route: `products/${route.params.id}`
    }
  }))

  const basicInfoCard = computed(() => ({
    title: trans('fleet/vehicle.basic_info'),
    component: columnsContentComponent,
    showButtons: true,
    fullWidth: true,
    showBackButton: {
      uiViewName: 'TemporaryRegulationsProducts'
    },
    rows: [
      {
        type: 'fields',
        columnsCount: 2,
        fields: [
          {
            key: 'description',
            label: trans('road-maintenance/patrol-service.description'),
            creatable: true,
            editable: true,
            visible: true
          },
          {
            key: 'barcode',
            label: trans('road-maintenance/inventory.barcode'),
            creatable: true,
            editable: true,
            visible: true
          },
          {
            key: 'type_id',
            label: trans('road-maintenance/inventory.item_category'),
            type: 'autocomplete',
            autocomplete_options: {
              module: 'road-maintenance',
              route: 'product-types',
              custom_display_value: (item) => {
                return trans(item?.description || '')
              },
              allowSearch: false
            },
            creatable: true,
            editable: true,
            visible: true
          },
          {
            key: 'unit_of_measure_id',
            label: trans('road-maintenance/settings.unit_of_measure'),
            type: 'autocomplete',
            items: unitOfMeasureItems.value,
            autocomplete_options: {
              custom_display_value: (item) => {
                return trans(item?.description || '')
              },
              allowSearch: false
            },
            creatable: true,
            editable: true,
            visible: true
          },
          {
            key: 'images',
            type: 'images-stack',
            label: trans('road-maintenance/patrol-service.photos'),
            maxImages: 3,
            deletedArrayKey: 'deleted_images',
            badgeConfig: {
              offsetX: 5,
              offsetY: 7,
              color: 'red'
            },
            imagesPreviewConfig: {
              title: (data) => {
                return trans('base.images_preview_title').replace(':custom-text', (data && data.barcode ? '- ' + data.barcode : ''))
              }
            },
            creatable: true,
            editable: true,
            visible: true
          }
        ]
      }
    ]
  }))

  const productDetailsCard = computed(() => ({
    subTitle: trans('road-maintenance/inventory.product_details'),
    component: columnsContentComponent,
    fullWidth: true,
    rows: [
      {
        type: 'fields',
        columnsCount: 4,
        fields: [
          {
            key: 'manufacturer',
            label: trans('road-maintenance/inventory.manufacturer'),
            creatable: true,
            editable: true,
            visible: true
          },
          {
            key: 'manufacturer_code',
            label: trans('road-maintenance/inventory.manufacturer_code'),
            creatable: true,
            editable: true,
            visible: true
          },
          {
            key: 'manufacture_date',
            label: trans('road-maintenance/inventory.manufacturer_date'),
            type: 'datetime-picker',
            subType: 'date',
            appendIcon: 'mdi-calendar-month',
            format: FORMATS.isoDate,
            placeholder: FORMATS.isoDate,
            creatable: true,
            editable: true,
            visible: true
          },
          {
            key: 'warranty_expiry_date',
            label: trans('road-maintenance/inventory.warranty_valid_until'),
            type: 'datetime-picker',
            subType: 'date',
            appendIcon: 'mdi-calendar-month',
            format: FORMATS.isoDate,
            placeholder: FORMATS.isoDate,
            creatable: true,
            editable: true,
            visible: true
          },
          {
            key: 'length',
            label: trans('base.length') + ' [cm]',
            creatable: true,
            editable: true,
            visible: true
          },
          {
            key: 'width',
            label: trans('base.width') + ' [cm]',
            creatable: true,
            editable: true,
            visible: true
          },
          {
            key: 'height',
            label: trans('base.height') + ' [cm]',
            creatable: true,
            editable: true,
            visible: true
          },
          {
            key: 'weight',
            label: trans('base.weight') + ' [kg]',
            creatable: true,
            editable: true,
            visible: true
          }
        ]
      }
    ]
  }))

  return computed(() => ({
    title: trans('fleet/vehicle.basic_info'),
    key: TAB_KEY,
    apiConfig: apiConfig.value,
    hiddenFormKeys: HIDDEN_FORM_KEYS,
    tabContent: [basicInfoCard.value, productDetailsCard.value]
  }))
}
